// Diagnosis rules — evaluated in order, first match wins
const DIAGNOSES = [
  {
    slug: 'surgical_menopause',
    check(a) {
      return a.q2 === 'ovaries_removed_recently' || a.q3 === 'no';
    }
  },
  {
    slug: 'poi',
    check(a) {
      return a.q1 === 'no' && a.q3 === 'yes' && (a.q6 === 'under_35' || a.q6 === '35_39');
    }
  },
  {
    slug: 'early_menopause',
    check(a) {
      return a.q1 === 'no' && a.q3 === 'yes' && a.q6 === '40_44';
    }
  },
  {
    slug: 'menopause',
    check(a) {
      return a.q1 === 'no' && ['45_49', '50_54', '55_59', '60_plus'].includes(a.q6);
    }
  },
  {
    slug: 'not_menopause',
    check(a) {
      const q4 = Array.isArray(a.q4) ? a.q4 : (a.q4 ? [a.q4] : []);
      const noSymptoms = q4.includes('none') || q4.length === 0;
      const youngAge = ['under_35', '35_39', '40_44'].includes(a.q6);
      return a.q1 === 'yes' && a.q2 === 'no' && noSymptoms && parseInt(a.q5 || 0) <= 1 && youngAge;
    }
  },
  {
    slug: 'perimenopause',
    check(a) {
      return a.q1 === 'yes' && parseInt(a.q5 || 0) >= 2;
    }
  }
];

class NeopauseQuiz {
  constructor(el) {
    this.el = el;
    this.answers = {};
    this.history = [];
    this.currentStep = 1;
    this.steps = [...el.querySelectorAll('[data-step]')];
    this.progressBar = document.querySelector('[data-nq-progress]');
    this.counter = document.querySelector('[data-nq-counter]');
    this.backBtn = el.querySelector('[data-nq-back]');
    this.init();
  }

  init() {
    this.el.addEventListener('click', (e) => {
      if (e.target.closest('[data-answer]')) this.handleAnswer(e.target.closest('[data-answer]'));
      if (e.target.closest('[data-nq-next]')) this.advance();
      if (e.target.closest('[data-nq-back]')) this.goBack();
    });
    this.el.addEventListener('submit', (e) => this.handleSubmit(e));
    this.showStep(1);
  }

  handleAnswer(btn) {
    const stepEl = btn.closest('[data-step]');
    const step = parseInt(stepEl.dataset.step);
    const value = btn.dataset.answer;
    const isMulti = stepEl.hasAttribute('data-multi');

    if (isMulti) {
      if (value === 'none') {
        stepEl.querySelectorAll('[data-answer].nq-selected').forEach(b => b.classList.remove('nq-selected'));
        btn.classList.add('nq-selected');
        this.answers[`q${step}`] = ['none'];
      } else {
        stepEl.querySelector('[data-answer="none"]')?.classList.remove('nq-selected');
        btn.classList.toggle('nq-selected');
        this.answers[`q${step}`] = [...stepEl.querySelectorAll('[data-answer].nq-selected')].map(b => b.dataset.answer);
      }
      const continueBtn = stepEl.querySelector('[data-nq-next]');
      if (continueBtn) {
        continueBtn.style.display = stepEl.querySelectorAll('[data-answer].nq-selected').length > 0 ? 'block' : 'none';
      }
    } else {
      stepEl.querySelectorAll('[data-answer]').forEach(b => b.classList.remove('nq-selected'));
      btn.classList.add('nq-selected');
      this.answers[`q${step}`] = value;
      setTimeout(() => this.advance(), 320);
    }
  }

  getNext(step) {
    if (step === 1) return this.answers.q1 === 'yes' ? 2 : 3;
    if (step === 2 || step === 3) return 4;
    return step + 1;
  }

  advance() {
    const next = this.getNext(this.currentStep);
    const target = this.el.querySelector(`[data-step="${next}"]`);
    if (target) {
      this.history.push(this.currentStep);
      this.showStep(next);
    }
  }

  goBack() {
    if (this.history.length === 0) return;
    this.showStep(this.history.pop());
  }

  showStep(stepNum) {
    this.steps.forEach(s => s.classList.remove('nq-active'));
    const target = this.el.querySelector(`[data-step="${stepNum}"]`);
    if (!target) return;
    target.classList.add('nq-active');
    this.currentStep = stepNum;
    this.updateProgress();
    if (this.counter) this.counter.textContent = `Question ${this.history.length + 1} of 9`;
    if (this.backBtn) this.backBtn.style.display = this.history.length > 0 ? 'flex' : 'none';
    this.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  updateProgress() {
    const map = { 1: 10, 2: 20, 3: 20, 4: 35, 5: 50, 6: 60, 7: 70, 8: 80, 9: 90, 10: 100 };
    if (this.progressBar) this.progressBar.style.width = `${map[this.currentStep] || 10}%`;
  }

  diagnose() {
    for (const rule of DIAGNOSES) {
      if (rule.check(this.answers)) return rule.slug;
    }
    return 'perimenopause';
  }

  handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    this.answers.email = form.querySelector('[name="email"]')?.value?.trim() || '';
    this.answers.name = form.querySelector('[name="name"]')?.value?.trim() || '';
    const diagnosis = this.diagnose();
    sessionStorage.setItem('neopause_diagnosis', diagnosis);
    sessionStorage.setItem('neopause_name', this.answers.name);
    sessionStorage.setItem('neopause_answers', JSON.stringify(this.answers));
    window.location.href = `/pages/results?diagnosis=${diagnosis}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('[data-neopause-quiz]');
  if (el) new NeopauseQuiz(el);
});
